// Configuração do Google reCAPTCHA v2 ("Não sou um robô").
//
// A SITE KEY é PÚBLICA — pode ficar no código (vai pro navegador de qualquer
// forma). NÃO é segredo. Já a SECRET KEY fica SÓ no backend (uenserver/.env,
// variável RECAPTCHA_SECRET) e nunca entra no front.
//
// 👉 Cole sua site key abaixo. Se preferir, dá pra sobrescrever por .env
//    (REACT_APP_RECAPTCHA_SITE_KEY) sem mexer aqui.
//
// Se ficar vazio, a página de validação libera sem exigir o captcha (modo dev).

export const RECAPTCHA_SITE_KEY =
    process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LfbSCUtAAAAABYKIH03LUqCyU3F4j7dS3ps5HSM';
